import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  GenericCardSpaces, GenericCardHeader, GenericCardFooter, GenericCardImage
} from '@design-system/components/templates/generic-card/entities/generic-card.types';
import { HeaderType, HeaderWidgetType } from '@design-system/components/templates/header/entities/header.types';
import { HeaderDsComponent } from '@design-system/components/templates/header/header.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { ButtonLinkDsComponent } from '@design-system/components/molecules/button-link/button-link.component';
import { ImageDsComponent } from '@design-system/components/molecules/image/image.component';
import {
  ButtonLinkType, ButtonLinkIconPosition
} from '@design-system/components/molecules/button-link/entities/button-link.types';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';
import { TagMemberDsComponent } from '@design-system/components/molecules/tag-member/tag-member.component';

@Component({
  selector: 'app-ds-generic-card',
  templateUrl: './generic-card.component.html',
  styleUrls: ['./generic-card.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    HeaderDsComponent,
    IconDsComponent,
    TypographyDsComponent,
    LoaderRingDsComponent,
    DividerDsComponent,
    ButtonLinkDsComponent,
    ImageDsComponent,
    TagMemberDsComponent,
  ]
})
export class GenericCardDsComponent {

  @Input() dsId: string;
  @Input() space = GenericCardSpaces.XXXS;
  @Input() highlight = false;
  @Input() header: GenericCardHeader;
  @Input() footer: GenericCardFooter;
  @Input() image: GenericCardImage;
  @Input() adjustedHeight = true;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickEventByFooter: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickEventByHeaderAction: EventEmitter<void> = new EventEmitter<void>();

  public readonly headerType = HeaderType.CardSelected;
  public readonly headerWidgetType = HeaderWidgetType.CardSelected;

  public readonly iconFillColor = IconFillColor;
  public readonly icons = Icon;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly buttonLinkType = ButtonLinkType;
  public readonly buttonLinkIconPosition = ButtonLinkIconPosition;

  public readonly imageSize = ImageSize.None;

  constructor() { }

}
